import type { StatusTone } from "@/components/status-badge"

import type { LotStatus, QCDecision } from "@/features/lots/api/types"

export function lotStatusTone(status: LotStatus): StatusTone {
  switch (status) {
    case "IN_PROGRESS":
      return "warning"
    case "COMPLETED":
      return "success"
    case "RECONDITIONED":
      return "muted"
  }
}

export function decisionTone(decision: QCDecision): StatusTone {
  switch (decision) {
    case "ACCEPTED":
      return "success"
    case "REJECTED":
      return "danger"
    case "PENDING":
      return "warning"
  }
}
